import { initializeApp, type FirebaseApp } from 'firebase/app'
import { getAuth, type Auth } from 'firebase/auth'
import { getFirestore, type Firestore } from 'firebase/firestore'

export const firebaseConfig = {
  apiKey: 'AIzaSyCxo1TJ9cpiP7bwqWx70ct3Shgy91L6-t0',
  authDomain: 'spinproj-2eae8.firebaseapp.com',
  projectId: 'spinproj-2eae8',
  storageBucket: 'spinproj-2eae8.firebasestorage.app',
  messagingSenderId: '998444747260',
  appId: '1:998444747260:web:80f558680f3c7a75f70a79',
  measurementId: 'G-TNYD85L79Q',
}

export const app: FirebaseApp = initializeApp(firebaseConfig)
export const auth: Auth = getAuth(app)
export const db: Firestore = getFirestore(app)

export const normalizeCode = (code: string): string =>
  code.trim().toUpperCase().replace(/\s+/g, '')
